<template>
    <ShowControl  @revert="revertClick"  :title="title" ref="showControl" :knowledgeType="Global.KnowledgeTypeList.filter(c=>c.name == '秩序维护')[0].value" >
    <div style="height: 90%;width: 90%;margin-top: 2%;overflow-x: hidden;overflow-y: auto;">
        <el-card>
          <el-row :gutter="20"
                  style="margin-top:10px;">
            <el-col :span="4">
              <el-image :src="Global.imgip + complaint.icon"
                        :fit="fill"
                        style="width:100%;height: 100%;" />
            </el-col>
            <el-col :span="20">
              <el-row :gutter="20"
                      style="margin-top:10px">
                <el-col :span="5"><span class="span">事件概述:</span></el-col>
                <el-col :span="6"><span class="span">{{complaint.name
              }}</span></el-col>
              </el-row>
              <el-row :gutter="20"
                      style="margin-top:10px">
                <el-col :span="5"><span class="span">严重等级:</span></el-col>
                <el-col :span="6">
                  <div style="text-align:left;margin-bottom:10px;"><span v-for="o in complaint.level"
                          :key="o">
                      <el-image :src="Global.imgip + 'resources/images/icons/leave.png'"></el-image>
                    </span></div>
                </el-col>
              </el-row>
              <el-row :gutter="20"
                      style="margin-top:10px">
                <el-col :span="5"><span class="span">事件详情:</span></el-col>
                <el-col :span="19"><span class="span">{{ complaint.description
              }}</span></el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-card>
        <el-row :gutter="20">
          <el-col v-for="(o, index) in AllHandle"
                  :key="index"
                  :span="6">
            <el-card style="margin-top:10px"
                     @click="selected(o)"
                     class="card"
                     :id="active_tab1.indexOf(o.id) == -1 ? '' : 'Handle'">
              <img :src="Global.imgip + o.icon"
                   :fit="cover"
                   class="image" />
              <div style="text-align:center;color:black;font-size: large;margin-top:10px">
                <span>{{ o.name }}</span>
              </div>
            </el-card>
          </el-col>
        </el-row>
        <el-row style="margin-top:10px">
          <span style="color:#ff5000;font-size:large">花费金额:￥{{ money }}元</span>
        </el-row>
        <el-row>
          <el-col :span="24"
                  style="text-align:right">
            <el-button @click="Emergencieshandle"
                       type="primary"
                       size="large">处理</el-button>
          </el-col>
        </el-row>
    </div>
    <div v-if="feedback" style="height: 100%;width: 90%;margin-top: 1%;">
        <h1 style="text-align:center;margin-bottom:10px">评价反馈</h1>
        <div style="text-align:center;width: 100%;">
          <el-image :src="Global.imgip + imgs"></el-image>
        </div>
        <el-row :gutter="20">
          <el-col :span="12">
            <div style="text-align:right">
              <el-image :src="Global.imgip + 'resources/images/complaints/cost.png'"
                        style="width:100px;height:100px">
              </el-image>
            </div>
          </el-col>
          <el-col :span="12"
                  style="margin-top:30px">
            <span style="color:#ff5000;font-size:large">花费金额:￥{{ money }}元</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24"
                  style="text-align:center">
            <el-button @click="returnview"
                       type="primary">返回</el-button>
          </el-col>
        </el-row>
    </div>
  </ShowControl>
  </template>
    <script>
  import { mapState } from "vuex";
  import emitter from '../../../unit/bus'
  import ShowControl from "../../UserControl/ShowControl.vue"
  export default {
    props: ["datas"],
    components: {
      ShowControl
    },
    data () {
      return {
        feedback: false,
        loding: false,
        caseID: localStorage.getItem("caseId"),
        flowID: localStorage.getItem("flowID"),
        AllHandle: [],
        active_tab1: [],
        money: 0,
        complaint: {},
        title: '秩序维护'
      };
    },
    computed: {
      ...mapState({
        Round: (state) => state.user.round,
        ChatShow:(state) => state.user.chatShows,
      }),
    },
    created () {
      this.GetEmergenciess()
      this.active_tab1 = [];
      this.money = 0
      this.GetAllHandle();
    },
    mounted() {
      this.$refs.showControl.receiveValue(true);
    },
    methods: {
      revertClick(){
      this.$router.push("/EmergenciesCard")
    },
      GetEmergenciess(){
        this.$http.get('Emergencies/GetModels?id='+this.$route.query.tid).then((res) => {
          if (res.success) {
            this.complaint = res.dynamicObj
          } else {
            this.$message.warning(res.message)
          }
        })
      },
      //获取所有的突发事件处理方式
      GetAllHandle () {
        this.$http.get('Handle/GetAllHandle?caseID=' + this.caseID).then((res) => {
          if (res.success) {
            this.AllHandle = res.dynamicObj
          }
        })
      },
      //选择处理方式
      selected (key) {
        let arrIndex = this.active_tab1.indexOf(key.id);
        if (arrIndex > -1) {   // 已选中,点击取消
          this.active_tab1.splice(arrIndex, 1);
          this.money = this.money - key.cost
        } else {  // 未选中,点击选中
          this.active_tab1.push(key.id);
          this.money = this.money + key.cost
        }
        this.active_tab1.sort((a, b) => {
          return a - b // 按升序排
        })
      },
      returnview () {
        this.feedback = false;
        this.GetAllEmergenciesModel()
      },
      //忽略
      ignore (index, row) {
        let list = [{
          round: parseInt(this.Round),
          type: "S_Emergencies",
          uuid: row.uuid,
          sTTime: this.filter.formatDate(new Date()),
          state: this.Global.SModel.Create,
          handles: null,
          satisfaction: -10,
          cost: 0,
        }];
        this.$http
          .post('SModel/PushStrategy', this.Global.getsmodel(list))
          .then((res) => {
            if (res.success) {
              this.Global.sendmsgmd(`会展服务`, `处理突发事件花费0元`, 1);
              this.GetAllEmergenciesModel()
            } else {
              this.$message.error(res.message);
              return false;
            }
          });
      },
      Emergencieshandle () {
        if (this.flowID != this.Global.FlowList.执行) {
          this.$message.error("当前流程阶段不是执行，无法进行操作！");
          return;
        }
        if (this.active_tab1.length != 0 && !this.Global.GetBudget(this.money)) {
          return this.$message.error("金额不足");
        }
        let handleID = '';
        if (this.active_tab1.length != 0) {
          this.active_tab1.forEach(item => {
            handleID += item + ','
          });
          handleID = handleID.substring(0, handleID.length - 1)
        }
        let Satisfaction = 0;
        var tHandlesLength = this.complaint.hanldles.length
        for (let i = 0; i < this.active_tab1.length; i++) {
          if (this.complaint.hanldles.filter(c=>c == this.active_tab1[i]).length >0) {
            Satisfaction += 1 / tHandlesLength * 100
          } else {
            Satisfaction += 10
          }
        }
        Satisfaction = Satisfaction > 100 ? 100 : Satisfaction
        let list = [{
          round: parseInt(this.Round),
          type: "S_Emergencies",
          uuid: this.$route.query.uuid,
          sTTime: this.filter.formatDate(new Date()),
          state: this.Global.SModel.Create,
          handles: handleID,
          satisfaction: parseInt(Satisfaction),
          cost: this.money,
          emergenciesID:  this.$route.query.id
        }];
        this.$http
          .post("SModel/PushStrategy", this.Global.getsmodel(list))
          .then((res) => {
            if (res.success) {
              this.Global.sendmsgmd(
                "会展服务",
                "处理突发事件花费" + this.money + "元",
                1
              );
              var incomet = [{
                buissType: this.Global.PayType.秩序维护,
                round: this.Round,
                buissValue: this.money,
                buissId: this.complaint.id,
              }];
              this.API.pushIncomet(incomet, 0);
              this.imgs = (Satisfaction >= 0 && Satisfaction <= 20) ? 'resources/images/complaints/bad.png' : (Satisfaction > 20 && Satisfaction <= 80) ? 'resources/images/complaints/so-so.png' : 'resources/images/complaints/good.png'
              emitter.emit("Emergencies", "发送")
              this.$store.commit("chatShow",{ isOperate : !this.ChatShow, chatValue: this.Global.OperateType.秩序维护 });  
              this.API.createTaskBar(this.Round,this.Global.EnumUserStatus.normal,'秩序维护');
              this.$router.push("/EmergenciesCard")
            } else {
              this.$message.error(res.message);
              return false;
            }
          });
  
      },
    },
  };
    </script>
    
    <style scoped>
  #Handle {
    background-color: orange;
  }
  .span {
    font-size: 30px;
  }
  
  .image {
    width: 100%;
    height: 100px;
    display: block;
  }
  </style>